import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import Avatar from 'primevue/avatar'
import AvatarGroup from 'primevue/avatargroup'
import Badge from 'primevue/badge'
import Breadcrumb from 'primevue/breadcrumb'
import Button from 'primevue/button'
import Calendar from 'primevue/calendar'
import Card from 'primevue/card'
import Checkbox from 'primevue/checkbox'
import Chip from 'primevue/chip'
import Chips from 'primevue/chips'
import Column from 'primevue/column'
import ContextMenu from 'primevue/contextmenu'
import Dialog from 'primevue/dialog'
import Divider from 'primevue/divider'
import Dropdown from 'primevue/dropdown'
import FileUpload from 'primevue/fileupload'
import FloatLabel from 'primevue/floatlabel'
import IconField from 'primevue/iconfield'
import InputGroup from 'primevue/inputgroup'
import InputGroupAddon from 'primevue/inputgroupaddon'
import InputIcon from 'primevue/inputicon'
import InputNumber from 'primevue/inputnumber'
import InputSwitch from 'primevue/inputswitch'
import InputText from 'primevue/inputtext'
import Menu from 'primevue/menu'
import Message from 'primevue/message'
import MultiSelect from 'primevue/multiselect'
import OverlayPanel from 'primevue/overlaypanel'
import PanelMenu from 'primevue/panelmenu'
import Password from 'primevue/password'
import Skeleton from 'primevue/skeleton'
import Stepper from 'primevue/stepper'
import StepperPanel from 'primevue/stepperpanel'
import Steps from 'primevue/steps'
import TabMenu from 'primevue/tabmenu'
import Tag from 'primevue/tag'
import Textarea from 'primevue/textarea'
import Toast from 'primevue/toast'
import { twMerge, type ClassNameValue } from 'tailwind-merge'
import { mergeProps } from 'vue'

// Import for override
import BaseConfirmDialog from 'primevue/confirmdialog'
import BaseDataTable from 'primevue/datatable'

export const primeVueComponents = [
  { name: 'Accordion', component: Accordion },
  { name: 'AccordionTab', component: AccordionTab },
  { name: 'Avatar', component: Avatar },
  { name: 'AvatarGroup', component: AvatarGroup },
  { name: 'Badge', component: Badge },
  { name: 'BaseConfirmDialog', component: BaseConfirmDialog },
  { name: 'BaseDataTable', component: BaseDataTable },
  { name: 'Breadcrumb', component: Breadcrumb },
  { name: 'Button', component: Button },
  { name: 'Calendar', component: Calendar },
  { name: 'Card', component: Card },
  { name: 'Checkbox', component: Checkbox },
  { name: 'Chip', component: Chip },
  { name: 'Chips', component: Chips },
  { name: 'Column', component: Column },
  { name: 'ContextMenu', component: ContextMenu },
  { name: 'Dialog', component: Dialog },
  { name: 'Divider', component: Divider },
  { name: 'Dropdown', component: Dropdown },
  { name: 'FileUpload', component: FileUpload },
  { name: 'FloatLabel', component: FloatLabel },
  { name: 'IconField', component: IconField },
  { name: 'InputGroup', component: InputGroup },
  { name: 'InputGroupAddon', component: InputGroupAddon },
  { name: 'InputIcon', component: InputIcon },
  { name: 'InputNumber', component: InputNumber },
  { name: 'InputSwitch', component: InputSwitch },
  { name: 'InputText', component: InputText },
  { name: 'Menu', component: Menu },
  { name: 'Message', component: Message },
  { name: 'MultiSelect', component: MultiSelect },
  { name: 'OverlayPanel', component: OverlayPanel },
  { name: 'PanelMenu', component: PanelMenu },
  { name: 'Password', component: Password },
  { name: 'Skeleton', component: Skeleton },
  { name: 'Stepper', component: Stepper },
  { name: 'StepperPanel', component: StepperPanel },
  { name: 'Steps', component: Steps },
  { name: 'TabMenu', component: TabMenu },
  { name: 'Tag', component: Tag },
  { name: 'Textarea', component: Textarea },
  { name: 'Toast', component: Toast },
]

export const primeVueTwMerger = (
  globalPTProps: Record<string, unknown> = {},
  selfPTProps: Record<string, unknown> = {},
  datasets: Record<string, unknown>,
) => {
  const merged = mergeProps(globalPTProps, selfPTProps, datasets)
  merged.class = twMerge(merged.class as ClassNameValue)
  return merged
}
